/*
 * @Author: edvardchen
 * @Date:   2016-11-13 15:54:55
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2020-01-02 22:16:32
 */

// @flow
import React from 'react';
import PropTypes from 'prop-types';

import autobind from 'core-decorators/lib/autobind';

import contextTypes from './contextTypes';
import { List } from './Comment';
// import styles from '../../containers/base.scss';
import { downloadBtn } from './ArticleContainer.scss';
import { praise } from '../../fetchers/circle_client';
import { localStorage } from '../../utility/storage';
import { track } from '../../utility';
import { loadDownloadScene } from '../../actions/sharepage';
import { refreshRMP } from '../../utility/ClipperForRMP';
import isFeedsFast from '../../utility/isFeedsFast';
import { isLoadKuaiBao, getProfileId } from '../../utility/PageConfigDataForShare';

const COMMENT_KEY = 'qb_commentpraises';

export default class CommentList extends React.PureComponent {
  static propTypes = {
    postInfo: PropTypes.object,
    exposureSharelp: PropTypes.object,
    dispatch: PropTypes.func,
  };

  static contextTypes = contextTypes;

  @autobind
  onItemClick() {
    // 产品要求点击评论项没有反应
    // const url = (window.location.href && window.location.href.indexOf('?') !== -1) ? `${window.location.href}&anchor=comment` : `${window.location.href}?anchor=comment`;
    // this.context.downloadOrOpenQb({
    //   url,
    //   label: 'single_comment',
    //   hideMaskModal: true
    // });

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_pinglun',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
  }

  @autobind
  onBottomClick() {
    this.props.dispatch(loadDownloadScene('comment')); // 点击推荐文章底部按钮，标志来源：文章正文
    refreshRMP(this.props.exposureSharelp && this.props.exposureSharelp.docId); // 推荐文章底部按钮，写入剪切板
    const url =
      window.location.href && window.location.href.indexOf('?') !== -1
        ? `${window.location.href}&anchor=comment`
        : `${window.location.href}?anchor=comment`;
    this.context.downloadOrOpenQb({
      url,
      label: 'comment_readAll',
      hideMaskModal: true,
    });

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_moreping',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: getProfileId() || (this.props.exposureSharelp && this.props.exposureSharelp.ch),
    });
  }

  @autobind
  // TODO: will be deleted in future
  // 因为没有 connect store，手动再次实现点赞缓存逻辑
  async onPraise(comment) {
    if (comment.praised) {
      return;
    }
    await praise(comment);
    const old = localStorage.getItem(COMMENT_KEY) || [];
    old.push(comment.id);
    localStorage.setItem(COMMENT_KEY, old);
    this.forceUpdate();
  }

  render() {
    const { valid, items, commentNum } = this.props.postInfo;
    if (!valid || !items || !items.length) {
      return null;
    }
    if (__CLIENT__) {
      const priasedList = localStorage.getItem(COMMENT_KEY) || [];
      this.props.postInfo.items.forEach((item) => {
        Object.assign(item, {
          praised: priasedList.indexOf(item.id) > -1,
        });
      });
    }
    const isKb = isFeedsFast();
    let btnText = isKb ? '打开天天快报极速版，查看全部评论' : '打开QQ浏览器，查看全部评论';

    // 拉新拉活看点快报
    const isKuaibao = isLoadKuaiBao();
    if (isKuaibao) {
      btnText = '打开看点快报，查看全部评论';
    }

    return (
      <div className="share" style={{ marginTop: '12px' }}>
        <List {...this.props.postInfo} onReply={this.onItemClick} onPraise={this.onPraise}>
          <div className="item">
            <div
              className={`${downloadBtn} ${isKb || isKuaibao ? 'is-kb__sharelp_btn' : ''}`}
              onClick={this.onBottomClick}
            >
              {/* <i className={styles.shareIcon}></i> */}
              {btnText}
              {commentNum ? <span>({commentNum})</span> : null}
            </div>
          </div>
        </List>
      </div>
    );
  }
}
